import type { TFunction } from 'i18next';
import { showDialog } from '@src/components';
import { profileHomePath } from '@src/components/AccountSwitcher/profiles';
import { santaClient } from '@src/state/client';

/** Same wallet + delete path as v1, for a registered account or a guest. */
export function confirmDeleteAccount(t: TFunction): void {
  void (async () => {
    let showWarning = false;
    try {
      const check = await santaClient.accountDeleteCheck();
      showWarning = Boolean(check.ok && check.data?.showWarning);
    } catch {
      // Still confirm — deletion must never skip the dialog.
    }
    showDialog({
      title: t('account.deleteTitle'),
      children: showWarning ? t('account.deleteWarning') : t('account.deleteConfirm'),
      cancel: t('account.deleteCancel'),
      submit: showWarning ? t('account.deleteAnyway') : t('account.deleteButton'),
      submitVariant: 'danger',
      onSubmit: async () => {
        const res = await santaClient.accountDelete();
        if (res.ok) {
          if (res.data?.profiles?.length) {
            const next = res.data.profiles.find((profile) => profile.active) || res.data.profiles[0];
            window.location.assign(profileHomePath(next));
            return;
          }
          window.localStorage.removeItem('refresh');
          window.location.assign('/');
          return;
        }
        throw new Error(res.error?.message || 'account.deleteFailed');
      },
      testId: 'account-delete-dialog',
    });
  })();
}
